<ppl-box-section
  [title]="title"
  [titleIcon]="titleIcon">
  @if (description) {
    <div class="description">{{ description }}</div>
  }
  <ng-content select="extra-description"></ng-content>
  <div class="entries">
    <div class="sub-title">{{ subTitle }}:</div>
    @for (entry of entries; track entry) {
      <ng-container *ngTemplateOutlet="entryTemplate; context: { $implicit: entry }"></ng-container>
    }
    <button
      class="add-button"
      pplButton
      pplButton1
      pplButtonSmall
      [disabled]="addButtonDisabled"
      (click)="add.emit()">
      {{ addButtonLabel }}
    </button>
  </div>
</ppl-box-section>

<ng-template
  #entryTemplate
  let-entry>
  <div class="entry">
    <div class="entry-data">
      <div
        class="entry-value text"
        [attr.title]="entry.value">
        {{ entry.value }}
      </div>
      <div class="entry-created text">{{ entry.created | pplDateTime }}</div>
    </div>
    <div class="entry-actions">
      <button
        class="delete-button"
        (click)="delete.emit(entry.id)">
        <ppl-icon
          svgIcon="trash-white"
          height="20px"
          width="19px"></ppl-icon>
      </button>
    </div>
  </div>
</ng-template>
